import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/explain',
    name: 'explain',
    component: () => import("../views/Home/explain"),
    meta: {
      keepAlive: true, //操作说明
    },
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import("../views/Home/AboutUs"),
    meta: {
      keepAlive: true, //此组件被缓存
    },
  },
  {
    path: '/daily',
    name: 'daily',
    component: () => import("../views/Home/daily"),
    meta: {
      keepAlive: true, //此组件被缓存
    },
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import("../views/Home/feedback"),
    meta: {
      keepAlive: true, //此组件被缓存
    },
  },
  {
    path: '/nongyao',
    name: 'nongyao',
    component: () => import("../views/Home/nongyao"),
    meta: {
      keepAlive: true, //此组件被缓存
    },
  },
]

const router = createRouter({
  mode: 'hash',
  history: createWebHashHistory(),
  routes
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0); // 将滚动位置设置为顶部
  next();
});
export default router
